const luggage_lost = `Subject: Lost Baggage Complaint
Dear Finnair Customer Service,
I am writing to report that my baggage was lost during my recent flight with Finnair. 
My baggage has not arrived at the destination with me, and this has caused me a lot of inconvenience.
I would appreciate your urgent assistance in locating my baggage and ensuring its prompt delivery to me. 
The contents of the baggage are important to me, and I am anxious to have them back as soon as possible.
I kindly request that you keep me informed of any updates regarding the status of my baggage and provide me with a timeline for its delivery. 
I trust that Finnair will take the necessary steps to resolve this matter quickly and efficiently.
Thank you for your prompt attention to this issue.
Sincerely,`;
export default luggage_lost;









